import React from 'react';
import { SVGAttributes } from 'react';

export const MedicalBoxColouredIcon: React.FC<SVGAttributes<never>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="pet-shop 1">
        <path
          id="Vector"
          d="M23.8418 62.2199C35.0383 57.1373 45.3618 59.4484 50.7574 57.0004C56.153 54.5506 66.0765 46.3053 54.8107 21.4839C43.5449 -3.33739 26.6489 -0.0627227 20.7129 2.63061C-7.07728 15.2439 4.01073 71.2208 23.8418 62.2199Z"
          fill="#EFEFEF"
        />
        <path
          id="Vector_2"
          d="M54.6999 7.86849C53.2296 7.86849 52.0332 6.67205 52.0332 5.20182C52.0332 3.7316 53.2296 2.53516 54.6999 2.53516C56.1701 2.53516 57.3665 3.7316 57.3665 5.20182C57.3665 6.67205 56.1701 7.86849 54.6999 7.86849ZM54.6999 4.31293C54.211 4.31293 53.811 4.71116 53.811 5.20182C53.811 5.69249 54.211 6.09071 54.6999 6.09071C55.1888 6.09071 55.5888 5.69249 55.5888 5.20182C55.5888 4.71116 55.1888 4.31293 54.6999 4.31293Z"
          fill="#FF7575"
        />
        <path
          id="Vector_3"
          d="M48.5262 49.1504H15.4738C13.5556 49.1504 12 47.5948 12 45.6766L12 23.3156C12 21.3974 13.5556 19.8418 15.4738 19.8418H48.5244C50.4427 19.8418 51.9982 21.3974 51.9982 23.3156V45.6748C52 47.5948 50.4444 49.1504 48.5262 49.1504Z"
          fill="#F3F3F1"
        />
        <path
          id="Vector_4"
          d="M52 23.3085V26.7751H12V23.3085C12 21.4062 13.5644 19.8418 15.4667 19.8418H48.5333C50.4356 19.8418 52 21.4062 52 23.3085Z"
          fill="#FF7575"
        />
        <path
          id="Vector_5"
          d="M19.0222 48.5665H15.4667C13.5644 48.5665 12 47.002 12 45.0998V23.3085C12 21.4062 13.5644 19.8418 15.4667 19.8418H19.0222C17.12 19.8418 15.5556 21.4062 15.5556 23.3085V45.0998C15.5556 47.002 17.12 48.5665 19.0222 48.5665Z"
          fill="#D5DBE1"
        />
        <path
          id="Vector_6"
          d="M19.0222 19.8418C17.12 19.8418 15.5556 21.4062 15.5556 23.3085V26.7751H12V23.3085C12 21.4062 13.5644 19.8418 15.4667 19.8418H19.0222Z"
          fill="#DE5761"
        />
        <path
          id="Vector_7"
          d="M48.5217 50.627H15.4692C12.8186 50.627 10.6621 48.4705 10.6621 45.8181L10.6648 23.3167C10.6648 20.6643 12.8212 18.5078 15.4719 18.5078H48.5243C51.175 18.5078 53.3314 20.6643 53.3314 23.3167L53.3288 45.8199C53.3288 48.4705 51.1723 50.627 48.5217 50.627ZM15.4719 21.1745C14.2914 21.1745 13.3314 22.1363 13.3314 23.3167L13.3288 45.8199C13.3288 47.0003 14.2888 47.9621 15.4692 47.9621H48.5217C49.7021 47.9621 50.6621 47.0003 50.6621 45.8199L50.6648 23.3167C50.6648 22.1363 49.7048 21.1745 48.5243 21.1745H15.4719Z"
          fill="black"
        />
        <path
          id="Vector_8"
          d="M12 25.6211H52V28.2878H12V25.6211Z"
          fill="black"
        />
        <g id="Group 30">
          <rect
            id="Rectangle 30516"
            x="29.5"
            y="32.4785"
            width="4.86785"
            height="10.7232"
            fill="#FE646F"
          />
          <rect
            id="Rectangle 30517"
            x="37.2988"
            y="35.4023"
            width="4.86785"
            height="10.7232"
            transform="rotate(90 37.2988 35.4023)"
            fill="#FE646F"
          />
          <path
            id="Vector_9"
            d="M26.0657 41.6248H28.4394V43.9985C28.4394 44.3132 28.5644 44.6151 28.787 44.8377C29.0096 45.0603 29.3115 45.1853 29.6262 45.1853H34.3735C34.6883 45.1853 34.9902 45.0603 35.2127 44.8377C35.4353 44.6151 35.5604 44.3132 35.5604 43.9985V41.6248H37.934C38.2488 41.6248 38.5507 41.4998 38.7732 41.2772C38.9958 41.0546 39.1208 40.7527 39.1208 40.438V35.6907C39.1208 35.3759 38.9958 35.074 38.7732 34.8515C38.5507 34.6289 38.2488 34.5038 37.934 34.5038H35.5604V32.1302C35.5604 31.8154 35.4353 31.5135 35.2127 31.291C34.9902 31.0684 34.6883 30.9434 34.3735 30.9434H29.6262C29.3115 30.9434 29.0096 31.0684 28.787 31.291C28.5644 31.5135 28.4394 31.8154 28.4394 32.1302V34.5038H26.0657C25.751 34.5038 25.4491 34.6289 25.2265 34.8515C25.0039 35.074 24.8789 35.3759 24.8789 35.6907V40.438C24.8789 40.7527 25.0039 41.0546 25.2265 41.2772C25.4491 41.4998 25.751 41.6248 26.0657 41.6248ZM27.2526 36.8775H29.6262C29.941 36.8775 30.2429 36.7525 30.4654 36.5299C30.688 36.3073 30.813 36.0054 30.813 35.6907V33.317H33.1867V35.6907C33.1867 36.0054 33.3117 36.3073 33.5343 36.5299C33.7569 36.7525 34.0588 36.8775 34.3735 36.8775H36.7472V39.2512H34.3735C34.0588 39.2512 33.7569 39.3762 33.5343 39.5988C33.3117 39.8213 33.1867 40.1232 33.1867 40.438V42.8116H30.813V40.438C30.813 40.1232 30.688 39.8213 30.4654 39.5988C30.2429 39.3762 29.941 39.2512 29.6262 39.2512H27.2526V36.8775Z"
            fill="black"
          />
        </g>
        <path
          id="Vector_10"
          d="M39.1194 18.5011V15.5164C39.1194 14.9669 38.0571 14.5215 36.7467 14.5215H27.2556C25.9451 14.5215 24.8828 14.9669 24.8828 15.5164V18.5011"
          stroke="black"
          strokeWidth="2.58065"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export default MedicalBoxColouredIcon;
